/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RsaDevice } from '../../models/rsa-device';
import { RsaDeviceCreateRequest } from '../../models/rsa-device-create-request';

export interface CreateRsaDevice$Params {
      body: RsaDeviceCreateRequest
}

export function createRsaDevice(http: HttpClient, rootUrl: string, params: CreateRsaDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RsaDevice>> {
  const rb = new RequestBuilder(rootUrl, createRsaDevice.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RsaDevice>;
    })
  );
}

createRsaDevice.PATH = '/api/v1/rsa/devices';
